import type { FunctionComponent } from 'react'
import React from 'react'
import { useParams } from 'react-router-dom'

import { useFeatureIsOn } from '@growthbook/growthbook-react'

import { addTrackingCode, isArticleInTest } from '../../../pages/article/utils/is-article-in-test'
import type { PageParams } from '../../../routes'
import { Link } from '../Link'
import styles from './ThirdPartyCTA.module.scss'

export const ThirdPartyCTA: FunctionComponent<Props> = ({ linkText, linkUrl, children }) => {
  const pageParams = useParams<PageParams>()
  const mortgageCtaTest = useFeatureIsOn('whc-992-mortgage-cta')
  const articleInTest = isArticleInTest(pageParams)
  const showVariant = articleInTest && mortgageCtaTest
  const href = addTrackingCode(linkUrl, articleInTest, showVariant)

  if (!children) {
    return null
  }

  return (
    <div className={styles.CTAContainer}>
      {children}
      {linkText && linkUrl ? (
        <Link href={href} target="_blank">
          {linkText}
        </Link>
      ) : null}
    </div>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  linkText?: string
  linkUrl?: string
}
